import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiple_select = _resolveComponent("multiple-select")!

  return (_openBlock(), _createBlock(_component_multiple_select, {
    value: _ctx.multipleValue,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.multipleValue) = $event)),
    placeholder: _ctx.placeholder,
    list: _ctx.multipleList,
    maxTagTextLength: _ctx.maxTagTextLength,
    maxTagCount: _ctx.maxTagCount,
    "class-name": _ctx.className
  }, null, 8, ["value", "placeholder", "list", "maxTagTextLength", "maxTagCount", "class-name"]))
}